import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Question } from '@models/dynamic-forms/question';

@Component({
  selector: 'app-textarea-input',
  templateUrl: './textarea-input.component.html',
  styleUrls: ['./textarea-input.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [ReactiveFormsModule],
})
export class TextareaInputComponent {
  @Input() public form: FormGroup;
  @Input() public question: Question;
}
